import './Teams.scss';

const Teams = () => {
    return (
        <section className='arta-teams'>
            <div className='arta-container'>
                <h2>Our Teams</h2>
                <p className="arta-teams__caption">
                    More than just a team, we're your partners in turning vision into reality.
                </p>
                <div className='arta-grid'>
                    <div className='arta-team-card'>
                        <div className='arta-team-card__content'>
                            <img
                                className='arta-team-card__content--thumbnail'
                                src={require("../../assets/images/leo.png")}
                                alt="Arta code connection"
                            />
                            <h4 className='arta-team-card__content--name'>Leonardo Doherty</h4>
                            <p className='arta-team-card__content--position'>Team Lead</p>
                        </div>
                    </div>

                    <div className='arta-team-card'>
                        <div className='arta-team-card__content'>
                            <img
                                className='arta-team-card__content--thumbnail'
                                src={require("../../assets/images/asrori.png")}
                                alt="Arta code connection"
                            />
                            <h4 className='arta-team-card__content--name'>M. Asrori</h4>
                            <p className='arta-team-card__content--position'>Full Stack Developer</p>
                        </div>
                    </div>

                    <div className='arta-team-card'>
                        <div className='arta-team-card__content'>
                            <img
                                className='arta-team-card__content--thumbnail'
                                src={require("../../assets/images/fikri.png")}
                                alt="Arta code connection"
                            />
                            <h4 className='arta-team-card__content--name'>Fikriansyah Dava</h4>
                            <p className='arta-team-card__content--position'>Quality Assurance</p>
                        </div>
                    </div>

                    <div className='arta-team-card'>
                        <div className='arta-team-card__content'>
                            <img
                                className='arta-team-card__content--thumbnail'
                                src={require("../../assets/images/Shafa.png")}
                                alt="Arta code connection"
                            />
                            <h4 className='arta-team-card__content--name'>Shafa Ayuning</h4>
                            <p className='arta-team-card__content--position'>Jr. Full Stack Developer</p>
                        </div>
                    </div>

                    <div className='arta-team-card'>
                        <div className='arta-team-card__content'>
                            <img
                                className='arta-team-card__content--thumbnail'
                                src={require("../../assets/images/via.png")}
                                alt="Arta code connection"
                            />
                            <h4 className='arta-team-card__content--name'>Oktavia Damayanti</h4>
                            <p className='arta-team-card__content--position'>Administrative Assistant</p>
                        </div>
                    </div>

                    <div className='arta-team-card'>
                        <div className='arta-team-card__content'>
                            <img
                                className='arta-team-card__content--thumbnail'
                                src={require("../../assets/images/ojit.png")}
                                alt="Arta code connection"
                            />
                            <h4 className='arta-team-card__content--name'>Firnas Amrozi</h4>
                            <p className='arta-team-card__content--position'>UI/UX Designer</p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default Teams;